<template>
  <div>
    <span v-if="showIcon && errors.has(inputId)" class="iconfont-error" aria-hidden="true" />
    <span v-if="errors.has(inputId)" class="message">{{ errors.first(inputId) }}</span>
  </div>
</template>

<script>
// @flow
/**
 * TODO: update and test form-group component to use this.
 * Handles showing errors from v-validate.
 * Expects an <input> in the <slot>
 */
export default {
  name: 'InputError',
  inject: ['$validator'], // adds parent validator
  props: {
    inputId: {
      type: String,
      required: true,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
